import * as React from 'react'
import {PageSection, Title} from '@patternfly/react-core'
import GenericBreadCrumb from 'src/frontend/app/components/GenericBreadCrumb'
import GenericCard from '../../components/GenericCard'
import GenericButton from '../../components/GenericButton'
import {
    PATH_TO_BO_ANAG_TRASF_ORDINE_RICHIESTA,
    PATH_TO_BO_ANAG_TRASF_ORDINE_RIFIUTA
} from 'src/app/utils/RoutesConstants'
import {convertUrlParamsToObject} from 'src/utilities/utility'
import GenericAlert from 'src/frontend/app/components/GenericAlert'
import {getSoggettoByIdIscrizioneBO} from 'src/processes/Soggetto'
import {FormRifiutaTrasferimentoOrdine} from './formTrasferimentoOrdine/FormRifiutaTrasferimentoOrdine'
import {isCurrentMobileDevice} from 'src/utilities/deviceUtility'

class RifiutaTrasferimentoOrdine extends React.Component<any, any> {
  constructor(props) {
    super(props)
    this.state = {
      message: '',
      typeMessage: 'default',
      idSoggetto: undefined,
      idIscrizione: undefined,
      idTrasferimentoOrdine: undefined,
    }
  }

  componentDidMount() {
    //recupero gli eventuali parametri dall'url
    var url = window.location.search?.split('?')[1]
    var urlParams = convertUrlParamsToObject(url)

    //recupero l'idIscrizione e l'idTrasferimentoOrdine dall'url
    var idTrasferimentoOrdine = urlParams?.idTrasferimentoOrdine
    var idIscrizione = urlParams?.idIscrizione

    getSoggettoByIdIscrizioneBO(idIscrizione).then((response) => {
      this.setState({ idSoggetto: response.data.idSoggetto })
    })

    this.setState({ idTrasferimentoOrdine: idTrasferimentoOrdine, idIscrizione: idIscrizione })
  }

  goToListaRichTrasferimento = (redirectLink: any) => {
    this.props.history.push({
      pathname: redirectLink,
    })
  }

  submitMessageResult = (alert: any) => {
    const element = document.getElementById('pageSectionId')
    if (element) element.scrollIntoView({ behavior: 'smooth' })
    this.setState({ message: alert.messaggio, typeMessage: alert.type })
    if (alert.type === 'success') {
      setTimeout(async () => {
        this.goToListaRichTrasferimento(PATH_TO_BO_ANAG_TRASF_ORDINE_RICHIESTA)
      }, 1000)
    }
  }

  render() {
    return (
      <>
        <PageSection id="pageSectionId">
          <div className="container register-container">
            <GenericBreadCrumb
              paths={[
                { label: 'Anagrafica', link: '#' },
                { label: 'Lista richieste di trasferimento ordine', link: PATH_TO_BO_ANAG_TRASF_ORDINE_RICHIESTA },
                { label: 'Rifiuta', link: PATH_TO_BO_ANAG_TRASF_ORDINE_RIFIUTA },
              ]}
            />
            <br></br>
            <Title headingLevel="h1" size="4xl">
              Rifiuta richiesta tradsferimento ordine
            </Title>
            <br></br>
            <GenericAlert hidden={this.state.message === ''} label={this.state.message} color={this.state.typeMessage}></GenericAlert>
            <GenericCard
              isExpandibleCard={false}
              header={'Compila i seguenti campi'}
              body={
                <FormRifiutaTrasferimentoOrdine
                  messaggio={this.submitMessageResult}
                  idIscrizione={this.state.idIscrizione}
                  idSoggetto={this.state.idSoggetto}
                  idTrasferimentoOrdine={this.state.idTrasferimentoOrdine}
                />
              }
            />
            <div className="row">
              <div className={isCurrentMobileDevice() ? null : 'col-1'}>
                <GenericButton label={'INDIETRO'} color={'secondary'} onClick={() => this.goToListaRichTrasferimento(PATH_TO_BO_ANAG_TRASF_ORDINE_RICHIESTA)} />
              </div>
              <div className={isCurrentMobileDevice() ? null : 'col-1'}>
                <GenericButton
                  label={'CONFERMA'}
                  color={'primary'}
                  type={'submit'}
                  form="rifiutaTrasfOrdine"
                  isDisabled={this.state.typeMessage === 'success'}
                />
              </div>
            </div>
          </div>
        </PageSection>
        <br />
        <PageSection>
          <div className="container register-container">
            <Title headingLevel="h3">Legenda</Title>
            <p>* Campo obbligatorio</p>
          </div>
        </PageSection>
      </>
    )
  }
}

export default RifiutaTrasferimentoOrdine
